import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Check Underline Circle".
 *
 * @property {string} [tooltip] - The tooltip to display on hover.
 */
@Component({
    selector: 'app-icon-check-underline-circle',
    templateUrl: './icon-check-underline-circle.component.html',
    styleUrls: ['./icon-check-underline-circle.component.scss'],
    standalone: false
})
export class IconCheckUnderlineCircleComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
